import { get, patch } from 'store/http/httpAction';
import { SET_GENERALSETTINGS_DATA } from './actionType';

const setGerenalSettings = settings => ({
  type: SET_GENERALSETTINGS_DATA,
  payload: { settings },
});

export const updateGerenalSettings = settings => dispatch => patch('/admin/settings-other', { update_options: settings }, dispatch).then((data) => {
  if (data && data.settings) {
    dispatch(setGerenalSettings(data.settings));
  }
});

export const fetchGeneralSettings = () => dispatch => get('/admin/settings-other', {}, dispatch).then((data) => {
  if (data && data.settings) {
    dispatch(setGerenalSettings(data.settings));
  }
});



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/flow/action.js